module.exports = __webpack_public_path__ + "img/icon-applesafari.d487b228.svg";